
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"113.75","height":"140","viewBox":"0 0 113.75 140"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"translate(-13.125)"}},[_c('circle',{attrs:{"cx":"52.5","cy":"52.5","r":"52.5","transform":"translate(17.5 30.625)","fill":"rgba(227,10,10,0)"}}),_c('path',{attrs:{"d":"M70 26.25a56.875 56.875 0 11-56.875 56.875A56.939 56.939 0 0170 26.25zm0 105a48.125 48.125 0 10-48.125-48.125A48.179 48.179 0 0070 131.25z"}}),_c('path',{attrs:{"d":"M105 48.124a4.361 4.361 0 01-3.094-1.281 4.375 4.375 0 010-6.187l10.938-10.938a4.375 4.375 0 016.187 0 4.375 4.375 0 010 6.187l-10.937 10.938A4.361 4.361 0 01105 48.124z"}}),_c('path',{attrs:{"d":"M118.125 39.375a4.361 4.361 0 01-3.094-1.281l-4.375-4.375a4.375 4.375 0 010-6.187 4.375 4.375 0 016.187 0l4.376 4.374a4.375 4.375 0 01-3.094 7.469zM70 35a4.375 4.375 0 01-4.375-4.375V4.375A4.375 4.375 0 0170 0a4.375 4.375 0 014.375 4.375v26.25A4.375 4.375 0 0170 35z"}}),_c('path',{attrs:{"d":"M83.125 8.75h-26.25A4.375 4.375 0 0152.5 4.375 4.375 4.375 0 0156.875 0h26.25A4.375 4.375 0 0187.5 4.375a4.375 4.375 0 01-4.375 4.375zM70.001 91.875a4.364 4.364 0 01-3.248-1.442L44.879 66.219a4.375 4.375 0 01.314-6.179 4.375 4.375 0 016.179.314l21.874 24.213a4.375 4.375 0 01-3.245 7.308z"}})])])
          )
        }
      }
    